// extracted by mini-css-extract-plugin
export default {"formWrapper":"AddPersonalDataForm_formWrapper__yQzeM"};